import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumPlannedStockFollowUpAction implements BaseEnumType {
  private static allValues: EnumPlannedStockFollowUpAction[] = []; // make sure this is top-most
  
  public static none = new EnumPlannedStockFollowUpAction(78, "None", "enum_planned_stock_follow_up_action_none");
  public static removeFromPlanned = new EnumPlannedStockFollowUpAction(82, "RemoveFromPlanned", "enum_planned_stock_follow_up_action_remove_from_planned");
  public static removeFromPlannedAndMoveToStock = new EnumPlannedStockFollowUpAction(85, "RemoveFromPlannedAndMoveToStock", "enum_planned_stock_follow_up_action_remove_from_planned_and_move_to_stock");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumPlannedStockFollowUpAction.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumPlannedStockFollowUpAction.none; }
  public isRemoveFromPlanned() { return this === EnumPlannedStockFollowUpAction.removeFromPlanned; }
  public isRemoveFromPlannedAndMoveToStock() { return this === EnumPlannedStockFollowUpAction.removeFromPlannedAndMoveToStock; }

  public static getValues(): readonly EnumPlannedStockFollowUpAction[] {
    return EnumPlannedStockFollowUpAction.allValues;
  }

  public static getValuesExcept0(): readonly EnumPlannedStockFollowUpAction[] {
    return EnumPlannedStockFollowUpAction.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumPlannedStockFollowUpAction {
    const found = EnumPlannedStockFollowUpAction.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumPlannedStockFollowUpAction - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumPlannedStockFollowUpAction): EnumPlannedStockFollowUpAction {
    const found = name ? EnumPlannedStockFollowUpAction.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumPlannedStockFollowUpAction - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumPlannedStockFollowUpAction>): boolean {
    return this.key === other?.key;
  }
}